function imageBanner() {
    const imageBanners = document.querySelectorAll(
        ".shopify-section.section--image-banner"
    );

    if (!imageBanners) return;

    imageBanners.forEach((banner) => {
        const elId = banner.getAttribute("id");

        const videoWrap = document.querySelector(`#${elId} .banner__video`);

        if (!videoWrap) return;

        videoInit(videoWrap, elId);
    });
}

function videoInit(el, sectionId) {
    const videoType = el.dataset.videoType;
    const videoId = el.dataset.videoId;
    const elId = el.getAttribute("id");
    if (!videoType && !videoId) return;

    if (videoType == "youtube") {
        createYouTubePlayer(elId, videoId, sectionId);
    } else if (videoType == "vimeo") {
        createVimeoPlayer(elId, videoId, sectionId);
    }
}

function createYouTubePlayer(elId, videoId, sectionId) {
    if (typeof YT == "undefined" || typeof YT.Player == "undefined") {
        loadYouTubePlayer();
        window.onYouTubePlayerAPIReady = function () {
            onYouTubePlayer();
        };
    } else {
        onYouTubePlayer();
    }

    function onYouTubePlayer() {
        player = new YT.Player(elId, {
            height: "390",
            width: "640",
            videoId: videoId,
            playerVars: {
                "enablejsapi": 1,
                "autoplay": 1,
                "rel": 0,
                "iv_load_policy": 3,
                "showinfo": 0,
                "modestbranding": 1,
                "playsinline": 1,
                "controls": 0,
                "color": "white",
                "mute": 1,
                "playlist": videoId,
                "vmode": "opaque",
                "vq": "hd720",
            },
            events: {
                "onReady": onPlayerReady,
                "onStateChange": onPlayerStateChange,
            },
        });
    }

    function onPlayerReady(event) {
        event.target.playVideo();
        hideCoverImages(sectionId);
    }
    function onPlayerStateChange(event) {
        if (event.data == YT.PlayerState.ENDED) {
            event.target.seekTo(0);
            event.target.playVideo();
        }
    }
}

function loadYouTubePlayer() {
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";

    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function createVimeoPlayer(elId, videoId, sectionId) {
    if (typeof Vimeo == "undefined" || typeof Vimeo.Player == "undefined") {
        var script = document.createElement("script");
        script.src = "https://player.vimeo.com/api/player.js";
        script.onload = onVimeoPlayer;
        document.head.append(script);
    } else {
        onVimeoPlayer();
    }

    function onVimeoPlayer() {
        const options = {
            id: videoId,
            autoplay: true,
            background: true,
            byline: false,
            controls: false,
            loop: true,
            dnt: true,
            muted: true,
            playsinline: true,
            portrait: false,
            title: false,
        };

        const vimeoPlayer = new Vimeo.Player(elId, options);

        vimeoPlayer.on("play", () => {
            hideCoverImages(sectionId);
        });
    }
}

function hideCoverImages(sectionId) {
    const mediaItems = document.querySelectorAll(
        `#${sectionId} .banner__media`
    );
    mediaItems.forEach((item) => {
        item.classList.add("banner__media--hidden");
        setTimeout(() => {
            item.style.display = "none";
        }, 700);
    });
}

document.addEventListener("DOMContentLoaded", () => {
    imageBanner();
});
